window.ensureThemeSwiper = function ensureThemeSwiper() {
  if (typeof Swiper !== 'undefined') {
    return Promise.resolve(window.Swiper);
  }

  if (window.__themeSwiperPromise) {
    return window.__themeSwiperPromise;
  }

  window.__themeSwiperPromise = new Promise(function (resolve, reject) {
    if (!window.__swiperAssetUrl) {
      reject(new Error('Missing swiper asset URL'));
      return;
    }

    var script = document.createElement('script');
    script.src = window.__swiperAssetUrl;
    script.async = true;
    script.onload = function () {
      resolve(window.Swiper);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return window.__themeSwiperPromise;
};
